import { useTranslation } from "react-i18next";

const LOCALE: Record<string, string> = { en: "en-US", es: "es" };

export function useLocale(): string {
  const { i18n } = useTranslation();
  return LOCALE[i18n.language?.slice(0, 2) ?? "en"] ?? "en-US";
}

export function formatDate(
  d: Date | string | number,
  locale: string,
  opts?: Intl.DateTimeFormatOptions,
): string {
  return new Intl.DateTimeFormat(locale, opts).format(new Date(d));
}

export function formatNumber(
  n: number,
  locale: string,
  opts?: Intl.NumberFormatOptions,
): string {
  return new Intl.NumberFormat(locale, opts).format(n);
}
